import { useState } from 'react';
import { ArrowRightLeft } from 'lucide-react';
import CompareThesesModal from './CompareThesesModal';

/**
 * CompareThesesButton — self-contained button + modal launcher.
 *
 * Drop anywhere you want to expose "Compare Theses". Owns its own
 * open/close state so the host page doesn't have to. Pass
 * `lockedTicker` to pin Stock A (Triangle tab + Triangle page) or
 * leave both empty for free-mode use (Watchlist Snapshot, Portfolio
 * Toolbox).
 *
 * Round 95al (Jun 2026).
 */
export default function CompareThesesButton({
  lockedTicker = null,
  label = 'Compare Theses',
  className = '',
  size = 'sm',
  testId = 'compare-theses-btn',
}) {
  const [open, setOpen] = useState(false);
  const sizeCls = size === 'xs'
    ? 'px-2 py-0.5 text-[10px]'
    : size === 'lg'
      ? 'px-3 py-2 text-sm'
      : 'px-2.5 py-1 text-xs';
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-1 rounded-md font-bold bg-violet-100 dark:bg-violet-950/40 text-violet-700 dark:text-violet-300 hover:bg-violet-200 dark:hover:bg-violet-950/60 border border-violet-300/60 transition-colors ${sizeCls} ${className}`}
        data-testid={testId}
        title={lockedTicker
          ? `Compare ${lockedTicker}'s thesis side-by-side with another ticker.`
          : 'Pick any two tickers and compare their Bull/Bear theses side-by-side.'}
      >
        <ArrowRightLeft className="w-3.5 h-3.5" />
        <span>{label}</span>
      </button>
      {open && (
        <CompareThesesModal
          onClose={() => setOpen(false)}
          lockedTicker={lockedTicker}
        />
      )}
    </>
  );
}
